import { render } from "./ButtonApprove.vue?vue&type=template&id=408b1754"
import script from "./ButtonApprove.vue?vue&type=script&lang=js"
export * from "./ButtonApprove.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__